import React from "react";
import PortMap from "../PortMap";
import Loader from '@/components/ui/loader';

const ViewPortDetails = ({ port, onCancel }) => {
  if (!port) {
    return (
      <div className="flex justify-center items-center h-96">
        <Loader size="lg" message="Loading port details..." />
      </div>
    );
  }

  const hasValidCoordinates = () => {
    if (port.coordinates && port.coordinates.lat && port.coordinates.lng) {
      return true;
    }
    if (port.latitude && port.longitude) {
      return true;
    }
    return false;
  };

  return (
    <div className="space-y-6">   
      <div className="">
       
        
        <div>
          {hasValidCoordinates() ? (
            <PortMap port={port} />
          ) : (
            <div className="h-64 flex items-center justify-center bg-muted rounded-lg">
              <p>Location data not available</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewPortDetails;